const object = {
  isEmpty(string) {
    return string === null || string === undefined || string.trim() == '';
  },
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  },
  isEmojiCharacter(substring) {
    for (var i = 0; i < substring.length; i++) {
      var hs = substring.charCodeAt(i);
      if (0xd800 <= hs && hs <= 0xdbff) {
        if (substring.length > 1) {
          var ls = substring.charCodeAt(i + 1);
          var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
          if (0x1d000 <= uc && uc <= 0x1f77f) {
            return true;
          }
        }
      } else if (substring.length > 1) {
        var ls = substring.charCodeAt(i + 1);
        if (ls == 0x20e3) {
          return true;
        }
      } else {
        if (0x2100 <= hs && hs <= 0x27ff) {
          return true;
        } else if (0x2B05 <= hs && hs <= 0x2b07) {
          return true;
        } else if (0x2934 <= hs && hs <= 0x2935) {
          return true;
        } else if (0x3297 <= hs && hs <= 0x3299) {
          return true;
        } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030 ||
          hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b ||
          hs == 0x2b50) {
          return true;
        }
      }
    }
  },
  standardPost(url, args) {
    var temp_form = document.createElement("form");
    temp_form.action = url;
    temp_form.target = "_self";
    temp_form.method = "post";
    temp_form.style.display = "none";
    for (var arg in args) {
      var opt = document.createElement("textarea");
      opt.name = arg;
      opt.value = args[arg];
      temp_form.appendChild(opt);

    }
    document.body.appendChild(temp_form);
    temp_form.submit();
  },
  $loadImage(url) {
    return new Promise((resolve, reject) => {
      let img = new Image()
      img.crossOrigin = "*"
      img.src = url + '?v=' + Math.random();
      img.onload = () => resolve(img)
      img.onerror = reject

    })
  }
}

const install = function (vm, options) {
  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      const element = object[key];
      vm.prototype[key] = element;
    }
  }

}
export default {
  install
}
